var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterKeyword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    fillRule: "nonzero",
    d: "M460.2 224.64l-4.982-4.982c.71-1.162 1.142-2.515 1.142-3.978 0-4.24-3.44-7.68-7.68-7.68s-7.68 3.44-7.68 7.68 3.44 7.68 7.68 7.68c1.463 0 2.816-.431 3.977-1.14l4.983 4.98c.35.35.93.348 1.28 0l1.28-1.28c.35-.35.35-.93 0-1.28zm-11.52-3.84c-2.827 0-5.12-2.293-5.12-5.12 0-2.828 2.292-5.12 5.12-5.12 2.828 0 5.12 2.292 5.12 5.12 0 2.827-2.293 5.12-5.12 5.12z",
    transform: "translate(-441 -208)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterKeyword);
export default __webpack_public_path__ + "static/media/filter-keyword.cab775967f2505026833460496a19342.svg";
export { ForwardRef as ReactComponent };